export { useMicroFrontendParams } from './use-micro-frontend-params.hook';
